((($, Drupal, once) => {
  /**
   * Character count behavior for textareas and text inputs with 'character-count' class.
   *
   * Usage:
   * 1. Add class 'character-count' to any textarea or text input
   * 2. Set the 'maxlength' attribute on the element
   * 3. The component will automatically add a character counter
   */
  Drupal.behaviors.characterCount = {
    attach(context) {
      $(
        once(
          'character-count-behavior',
          'textarea.character-count, input[type="text"].character-count, input[type="email"].character-count, input[type="tel"].character-count, input[type="url"].character-count',
          context,
        ),
      ).each(function () {
        const $field = $(this);
        const maxLength = parseInt($field.attr('maxlength'), 10);

        // Skip if no maxlength is set
        if (!maxLength || maxLength <= 0) {
          console.warn('Character count component: maxlength attribute is required on field with class "character-count"');
          return;
        }

        // Create character count display using existing CSS classes
        const $characterCountDisplay = $(`<div class="character-count-style"><span class="current-count">0</span>/${maxLength}</div>`);

        // Insert the display after the field
        $field.after($characterCountDisplay);

        // Update character count on input
        $field.on('input keyup paste', () => {
          updateCharacterCount($field, $characterCountDisplay, maxLength);
        });

        // Initial count update
        updateCharacterCount($field, $characterCountDisplay, maxLength);
      });
    },
  };

  /**
   * Updates the character count display and handles validation.
   *
   * @param {jQuery} $field - The textarea or input element
   * @param {jQuery} $display - The character count display element
   * @param {number} maxLength - Maximum allowed characters
   */
  function updateCharacterCount($field, $display, maxLength) {
    const currentLength = $field.val().length;
    const $currentCount = $display.find('.current-count');

    // Update the current count
    $currentCount.text(currentLength);

    // Add appropriate classes based on character count (for potential future styling)
    $display.removeClass('character-count-warning character-count-over');

    if (currentLength > maxLength) {
      $display.addClass('character-count-over');
    } else if (currentLength > maxLength * 0.8) {
      $display.addClass('character-count-warning');
    }

    // Trigger custom event for other components to listen to
    $field.trigger('characterCountUpdated', {
      currentLength,
      maxLength,
      isOver: currentLength > maxLength,
      isWarning: currentLength > maxLength * 0.8,
    });
  }
}))(jQuery, Drupal, once);
